import { useQuery } from "@apollo/client";
import { EventDetailsDocument } from "../../../../../../__generated__/graphql";

export default function useEventDetails(eventId?: string | null) {
  const { data, loading, error } = useQuery(EventDetailsDocument, {
    variables: { eventId: eventId || "" },
    skip: !eventId,
  });

  return {
    data,
    loading,
    error,
  };
}
